import { getRouteApi } from '@tanstack/react-router';

const realmRoute = getRouteApi('/_app/realm/$realmKey');

/**
 * Whether nothing in the open realm can be changed here: someone else's, shared with this
 * account to read (docs/SHARING-PLAN.md section 3.4), a preview, or one whose edit lease
 * someone else holds (docs/SHARING-CO-OWNERS-PLAN.md section 3.4). Pages hide what would
 * change it; the realm worker refuses any change all the same.
 */
export function useReadOnly(): boolean {
  return realmRoute.useLoaderData().readOnly;
}
